import React from "react";

import "./ProjectsSection.css";
import { useTranslation } from "react-i18next";

import ProjectContainer from "../ProjectContainer/ProjectContainer";
import CommingSoon from "../../Images/ComingSoon.jpg";
import Jonis27Image from "../../Images/Jonis27Image.jpg";

const ProjectsSection: React.FC = () => {
  const { t } = useTranslation() as { t: (key: string) => string };

  return (
    <div className="projectsSection">
      <h2>{t("personalProjects")}</h2>
      <div className="projects_container">
        <ProjectContainer
          text="Jonis27 portfolio"
          imageSrc={Jonis27Image}
          newPageURL="https://jonis27-b8b7b.web.app/"
        />
        <ProjectContainer
          text="Caligotec"
          imageSrc={CommingSoon}
          newPageURL="https://Caligotec.com"
        />
      </div>
    </div>
  );
};

export default ProjectsSection;
